export const data = [
  {
    title: 'Work Order Creation',
    items: [
      {
        title: 'How do I create a work order?',
        description:
          'To create a work order, you can press the + button at the bottom of the screen. Describe the issue you are seeing and press submit. Once submitted you can add detail and assign to someone on your team.',
      },
      {
        title: 'What happens when I finish work order creation?',
        description:
          'Once you have assigned the work order to a team member and saved, that person receives a notification of their new work order. Once they begin work, they will update the status to "In Progress". You will receive a notification that the work order\'s status has changed.',
      },
      {
        title: 'How does the vendor selection program work?',
        description:
          'When you request vendor quotes from ProCure, we reach out to our network of trusted service providers to find people that are ready to provide quality service for a good rate. We will send you two quotes and let you take it from there.',
      },
    ],
  },
  {
    title: 'Work Order Management',
    items: [
      {
        title: 'How do I make changes after I have created a work order?',
        description:
          "To update a work order, simply go to the work order dashboard and find the work order you wish to edit. Once in the work order you can update the work order's title, status, priority, or assignee. If you wish to update anything else, click the edit icon at the top right. You can update the description, change the due date, or modify the area and follower selection.",
      },
      {
        title: 'How do I check in on how a job is coming along?',
        description:
          'To stay up to date on a work order, you can add yourself as a follower. You will then be notified any time the work order is updated. If you do not want to be a follower, you can simply find the work order on the dashboard and go into its details. There you can see all comments added to the work order, leave questions and comments for the team, and review any files added to the work order.',
      },
      {
        title: 'How can I identify jobs that might need me to get involved?',
        description:
          'To identify issues that might need your attention, you can look for any work orders that are past due, that have been open for a long time, or that are urgent. You can use the work order sorting and filtering options to pinpoint each of these types of work orders.',
      },
    ],
  },
  {
    title: 'Managing My Account',
    items: [
      {
        title: 'How do I update my contact information?',
        description:
          'To update your contact information, click the user settings icon at the top right from the home screen. From there you can change your name or click Change for phone number or email. Once you enter the new information you will be asked to verify again by entering a code sent to that contact.',
      },
      {
        title: 'How do I close my account?',
        description:
          'To delete your account, click the user settings icon at the top right of the home screen. From there you can click Delete Account.',
      },
      {
        title: 'How do I update my preferences?',
        description:
          'To update preferences, click the user settings icon at the top right of the home screen. Select Notifications Settings to update which notifications you receive and how you receive them.',
      },
    ],
  },
  {
    title: 'Managing My Organization',
    items: [
      {
        title: "How do I update my organization's users?",
        description:
          'To update your organizations users, go to Organization Settings by clicking the building icon at the top left of the home screen. You can click any users to update their properties or remove them from the organization. You can also press the + button to add new users.',
      },
      {
        title: "How do I update my organization's properties?",
        description:
          'To update your organizations properies, go to Organization Settings by clicking the building icon at the top left of the home screen. Click the tab for Properties. You can click any property to update the team, review work orders, or add a work order to that property. You can also edit the property, remove the property, or add a new property to the organization.',
      },
      {
        title: 'How do I remove my organization from ProCure?',
        description:
          'To remove your organization from ProCure, go to Organization Settings by clicking the building icon at the top left of the home screen. You can then click the edit icon at the top right, which will allow you to delete the organization.',
      },
    ],
  },
];
